import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(() => ({
  placeholderText: {
    textAlign: "center",
  },
  placeholderCard: {
    display: "inline-block",
    borderRadius: 8,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    transform: "scale(1)", // Force GPU acceleration
  },
  stablePlaceholderContainer: {
    transition: "opacity 0.3s ease",
    marginBottom: "0.5em",
  },
}));
